import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { blobURL } from '../../common/StringUtils';
import { LOCALES } from '../../common/constants';
import './express-payment-modal.scss';

interface ExpressPaymentModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  calculatedAmount?: number;
  currency?: string;
}

const ExpressPaymentModal: React.FC<ExpressPaymentModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  calculatedAmount = 0,
  currency = 'SEK'
}) => {
  const { t } = useTranslation();
  const language = localStorage.getItem('i18nextLng');
  
  const expressDe = `${blobURL}/express-logo-de.png`;
  const expressEng = `${blobURL}/express-logo-eng.png`;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      size="lg"
      className="express-payment-modal"
    >
      <Modal.Header closeButton className="border-0 pb-2">
        <Modal.Title className="w-100 text-center">
          <h5 className="modal-title-text mb-0">{t('EXPRESS_PAYMENT_REQUIREMENTS')}</h5>
        </Modal.Title>
      </Modal.Header>
      
      <Modal.Body className="pt-2 pb-4 px-4">
        <div className="express-payment-content">
          <p className="info-text mb-3" style={{ fontSize: '14px', lineHeight: '1.6', color: '#333' }}>
            {t('EXPRESS_PAYMENT_INFO_TEXT_1')}
          </p>
          
          <p className="info-text mb-3" style={{ fontSize: '14px', lineHeight: '1.6', color: '#333' }}>
            {t('EXPRESS_PAYMENT_INFO_TEXT_2')}
          </p>

          <p className="requirement-text mb-2" style={{ fontSize: '14px', lineHeight: '1.6', color: '#333' }}>
            {t('EXPRESS_PAYMENT_REQUIREMENTS_TEXT')}
          </p>
        </div>
      </Modal.Body>
      
      <Modal.Footer className="border-0 pt-0 pb-4 px-4">
        <Button 
          variant="primary" 
          onClick={handleConfirm}
          className="w-100"
          style={{
            backgroundColor: '#6C5CE7',
            borderColor: '#6C5CE7',
            borderRadius: '24px',
            padding: '12px 24px',
            fontSize: '16px',
            fontWeight: '600'
          }}
        >
          {t('GOT_IT')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ExpressPaymentModal;
